import clsx from 'clsx';
import { ReviewStatusType } from '../../../../types/reviewStatus';
import { checkbox, closeCircle, hourglass } from 'ionicons/icons';

export const docReviewStatusStyle = (status: ReviewStatusType) =>
  clsx(
    'border',
    status === 'approved' &&
      'border-green-500 bg-green-50 text-green-500 fill-green-500',
    status === 'pending' &&
      'border-yellow-500 bg-yellow-50 text-yellow-500 fill-yellow-500 ',
    // status === 'required' &&
    //   'border-gray-500 bg-gray-50 text-gray-500 fill-gray-500',
    status === 'rejected' &&
      'border-red-500 bg-red-50 text-red-500 fill-red-500'
  );

export const getDocReviewStatusIcon = (status: ReviewStatusType) => {
  // if (status === 'required') return alertCircle;
  if (status === 'rejected') return closeCircle;
  if (status === 'pending') return hourglass;
  return checkbox;
};
